import { render } from "./index.vue?vue&type=template&id=8286f14c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=8286f14c&lang=scss&scoped=true"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8286f14c"],['__file',"src/views/widget/shop/product/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8286f14c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8286f14c', __exports__)) {
    console.log('reload')
    api.reload('8286f14c', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=8286f14c&scoped=true", () => {
    console.log('re-render')
    api.rerender('8286f14c', render)
  })

}


export default __exports__